import React, { useCallback } from "react";
import { ORDER_TYPE } from "src/shared/interfaces";
import { Icon, TableProperty } from "src/shared/components";
import { IconType } from "src/shared/components/Icon/Icon";

import "./index.scss";


interface ISortableHeaderProps<T> {
  column: TableProperty<T>;
  sortOrder?: ORDER_TYPE;
  onChangeSorting?: (fields: string[] | undefined, order: ORDER_TYPE) => void;
}

function SortableHeader<T>(props: ISortableHeaderProps<T>) {
  const { sortOrder, onChangeSorting, column } = props;

  const handleChangeSorting = useCallback(() => {
    const orderTypes = Object.values(ORDER_TYPE);
    const nextOrderType = orderTypes[(orderTypes.indexOf(sortOrder || ORDER_TYPE.NONE) + 1) % orderTypes.length];

    if (onChangeSorting) {
      onChangeSorting(column.sort, nextOrderType);
    }
  }, [onChangeSorting, sortOrder, column]);

  return (
    <div className="sortable-header" onClick={() => handleChangeSorting()}>
      <Icon className="sort-icon" type={`sort${sortOrder ? `-${sortOrder.toLowerCase()}` : ""}` as IconType} />
      <div>{column.title}</div>
    </div>
  );
}

export default SortableHeader;
